import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "form"]

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  confirm() {
    this.formTarget.requestSubmit()
  }

  // Close on backdrop click
  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
